/*
Defines the custom element <ravel-v-stream>
*/

import { RavelSignalCollector } from './src/RavelSignalCollector.js';

customElements.define('ravel-signal-collector', RavelSignalCollector);
